<template>
  <div class="cb-navigation light-theme" @keydown="setFocus">
    <nav class="cb-navigation__container" role="navigation">
      <button
        @click="handleCloseClick"
        class="cb-navigation__close"
        ref="closeModalButton"
        data-tab-order="first"
        aria-label="Close Navigation"
      >
        <img alt src="../assets/icons/close-modal.svg" />
      </button>
      <ul class="cb-navigation__list">
        <li v-if="showTroubleshootLink">
          <img alt src="../assets/icons/question-mark.svg" /><a
            href
            @click.prevent="handleNavigationClick('troubleshoot')"
            class="cb-link"
            >Troubleshooting</a
          >
        </li>
        <li>
          <img alt src="../assets/icons/sign-out.svg" /><a
            href
            data-tab-order="last"
            @click.prevent="handleSignOut"
            class="cb-link"
            >Sign Out</a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapMutations } from 'vuex';
import focusTrapping from '../mixins/focusTrapping';

export default {
  props: {
    showTroubleshootLink: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$refs.closeModalButton.focus();
    document.addEventListener('keydown', this.handleEscapeKeyPress);
  },
  beforeDestroy() {
    const $navButton = document.getElementById('open-nav');
    if ($navButton) {
      $navButton.focus();
    }
    document.removeEventListener('keydown', this.handleEscapeKeyPress);
  },
  methods: {
    handleNavigationClick(route) {
      this.$router.push(`/${route}`);
      this.setIsNavigationModalOpen(false);
      gtag('event', `${route} click`, {
        event_label: `${route}`,
        event_category: 'navigationModal',
        value: 1,
      });
    },
    handleSignOut() {
      this.logout();
      this.setIsNavigationModalOpen(false);
      this.$router.push('/');
      gtag('event', 'signOutClick', {
        event_label: 'sign out',
        event_category: 'navigationModal',
        value: 1,
      });
    },
    handleCloseClick() {
      this.setIsNavigationModalOpen(false);
      gtag('event', 'closeModalClick', {
        event_label: 'close',
        event_category: 'navigationModal',
        value: 1,
      });
    },
    handleEscapeKeyPress(e) {
      if (e.keyCode === 27) {
        this.setIsNavigationModalOpen(false);
      }
    },
    ...mapMutations(['setIsNavigationModalOpen']),
    ...mapActions(['logout']),
  },
  mixins: [focusTrapping],
};
</script>

<style lang="scss" scoped>
.cb-navigation {
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0;
  right: 0;

  &__container {
    display: flex;
    flex-direction: column;
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    width: 100%;
    max-width: 522px;
    left: 50%;
    transform: translateX(-50%);
    padding: 20px;
    z-index: 1000;
    border-radius: 10px 10px 0 0;
    background-color: white;
    box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),
      0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 11px 15px -7px rgba(0, 0, 0, 0.2);
  }

  &__close {
    align-self: flex-end;
    border: 0;
    background-color: transparent;
    padding: 0;
    height: 18px;
    width: 18px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  &__list {
    margin: 0;
    padding: 0 22px;
    list-style: none;

    li {
      display: flex;
      align-items: center;
      padding: 14px 0;
      font-size: 17.6px;
      font-weight: 600;

      img {
        margin-right: 12px;
      }
    }
  }

  @include desktop {
    &__container {
      height: fit-content;
      width: 365px;
      padding-bottom: 54px;
      top: 20px;
      right: 50px;
      border-radius: 10px;
      transform: none;
      left: auto;
    }
  }
}
</style>
